import { Mark } from 'tiptap';
import {
	markInputRule,
	updateMark,
	// removeMark,
} from 'tiptap-commands';

/**
 * Background Color - Extends the built in Mark from tiptap allowing
 * the editor to <drumroll> set the font-size.
 */
export default class BackgroundColor extends Mark {
	// eslint-disable-next-line class-methods-use-this
	get name() {
		return 'backgroundColor';
	}

	// eslint-disable-next-line class-methods-use-this
	get schema() {
		return {
			attrs: {
				color: {
					default: '#fff',
				},
			},
			parseDOM: [
				{
					style: 'background-color',
					// getAttrs: value => value.indexOf('em') !== -1 ? {fontSize:value} : '',
					getAttrs: value => ({ 'background-color': value }),
				},
			],
			toDOM: mark => ['span', { style: `background-color: ${mark.attrs.color}` }, 0],
		};
	}

	// eslint-disable-next-line class-methods-use-this
	commands({ type }) {
		// console.log('type: ', type);
		return attrs => updateMark(type, attrs);
	}

	// eslint-disable-next-line class-methods-use-this
	inputRules({ type }) {
		return [
			markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
		];
	}
}
